<template>
    <div class="full-wdith-editor">
        <div class="editor-title-toolbar">
            <ReturnButton
                class="return-btn"
                @click="clickReturnBtn"
                v-show="showReturnBtn !== null && showReturnBtn !== false"
                :label="returnLabel"
            />

            <div>
                <h2 tkey="產品管理">{{i18n.tkey("lang_product_manager")}}</h2>
            </div>

            <div class="right-operation-btn" v-if="viewPart === 'list'">
                <el-button type="primary" @click="goAddItem" tkey="添加產品">{{i18n.tkey("lang_add_product")}}</el-button>
            </div>
        </div>

        <ShopItemRecord @goEdit="goEditItem" @goAdd="goAddItem2" v-if="viewPart === 'list'" />

        <InsertOrEditMaterial :editObj="editObj" @changeMaterial="getShopItemList" v-if="viewPart === 'edit'||viewPart === 'add'" />
    </div>
</template>

<script setup>

import InsertOrEditMaterial from "@/components/shopopee/material/insertOrEditMaterial.vue";
import ShopItemRecord from "@/components/shopopee/shop/shopItemRecord.vue";
import ReturnButton from "@/components/shopopee/common/returnButton.vue";
import myUtil from "@/util/util";
import {inject, ref, computed, toRef, onMounted, getCurrentInstance} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import materialApi from "@/request/materialApi";


const props = defineProps(["showReturnBtn"])
const emits = defineEmits(["clickReturnBtn"])

const i18n = inject("i18n")

const userinfoRef = toRef(useUserinfo())
const viewPart = ref("list")
const editObj = ref(null)

const returnLabel = computed(() => {
    let text = i18n.tkey("lang_return_control_room")

    if (viewPart.value === "edit"){
        text = i18n.tkey("lang_return")
    }

    return text

})

function goAddItem(){
    viewPart.value = "edit"
}
function goAddItem2(){
  viewPart.value = "add"
}


function goEditItem(item){
    editObj.value = item
    viewPart.value = "edit"
}

function clickReturnBtn(){
    if (viewPart.value === "edit"){
        viewPart.value = "list"
        editObj.value = null
    }else{
      if(myUtil.isNotEmpty(clickReturnBtn)){
        emits("clickReturnBtn")
      }
    }

}

function getShopItemList(productid){
  const request = materialApi.queryMaterial
  const params = request.getParams()

  viewPart.value="list"
  //params.companycode = shopCompany.value.companycode
  params.companycode =userinfoRef.value.selectCompanycode
  params.productid = productid

  request.send(params, (res) => {
    if (res.code == 200){
      var datam = res.detail
      if(datam.length>0){
        editObj.value = datam[0];
        viewPart.value="edit"
      }
    }
    //P00047
  })
}



</script>

<style scoped>
    .full-wdith-editor {
        width: 100%;
    }

    .editor-title-toolbar {
        text-align: center;
        position: relative;
        margin-bottom: 32px;
    }

    .editor-title-toolbar .return-btn {
        position: absolute;
        left: 0;
        top: 5px;
    }

    .editor-title-toolbar .right-operation-btn {
        position: absolute;
        right: 0;
        top: 0;
    }

</style>